import { render, staticRenderFns } from "./EditorBlockVideo.vue?vue&type=template&id=10147e60&scoped=true"
import script from "./EditorBlockVideo.vue?vue&type=script&lang=js"
export * from "./EditorBlockVideo.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockVideo.vue?vue&type=style&index=0&id=10147e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10147e60",
  null
  
)

export default component.exports